import React from 'react';
import { toast } from 'sonner';
import { ExternalLinkIcon, ScaleIcon } from 'lucide-react';
import { formatUsd, sumCents } from '../../utils/format';
import { Badge } from '../sf/Badge';
import { Card } from '../sf/Card';
import { Td, Th } from '../sf/DataTable';
interface ParityCardProps {
  legacyAdjusted: number;
  legacyStored: number;
  newAdjustedTotal: number;
  newStoredTotal: number;
  mismatches: number;
}
export function ParityCard({
  legacyAdjusted,
  legacyStored,
  newAdjustedTotal,
  newStoredTotal,
  mismatches
}: ParityCardProps) {
  const rows = [{
    label: 'Adjusted',
    basis: 'Adjusted Loan Amount × BPS · pays',
    legacy: legacyAdjusted,
    next: newAdjustedTotal,
    primary: true
  }, {
    label: 'Stored (unadjusted) – reference',
    basis: 'Loan Amount × BPS',
    legacy: legacyStored,
    next: newStoredTotal,
    primary: false
  }];
  return <Card title="Parity" icon={ScaleIcon} iconBg="#06A59A" meta="Legacy (Salesforce main) vs new · both sides include TL / Director rows" bodyClassName="" actions={<button type="button" onClick={() => toast('Diff report opened', {
    description: 'October 2026 · line-level legacy vs new comparison.'
  })} className="inline-flex items-center gap-1 rounded text-[13px] text-sf-blue hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sf-blue" data-id="element-682" data-mp="1a0gwdmrmgbua">
          Open diff report <ExternalLinkIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-683" data-mp="1srrjrty526hf" />
        </button>} data-id="element-681" data-mp="2j76phw8gqpad">
      <table className="w-full border-collapse" data-id="element-684" data-mp="1ntq0p90pq75y">
        <thead data-id="element-685" data-mp="21tr1kogz9elf">
          <tr data-id="element-686" data-mp="21ualgaq6ud23">
            <Th data-id="element-687" data-mp="21spqwl3viu48">Basis</Th>
            <Th align="right" data-id="element-688" data-mp="21t7u61oye8ln">Legacy</Th>
            <Th align="right" data-id="element-689" data-mp="1xsp3wc2plalk">New</Th>
            <Th align="right" data-id="element-690" data-mp="1xtqmd1m20zdb">Difference</Th>
          </tr>
        </thead>
        <tbody data-id="element-691" data-mp="7f810rfzxl61">
          {rows.map(row => {
          const diff = sumCents([row.next, -row.legacy]);
          const tone = row.primary ? 'font-semibold text-sf-text' : 'text-[12px] text-sf-weak';
          return <tr key={row.label} data-id="element-692" data-mp="22kpjs1lrm0bp">
                <Td className={row.primary ? 'font-semibold' : 'text-sf-weak'} data-id="element-693" data-mp="27i985uc6fthd">
                  {row.label}
                  <span className="block text-xs font-normal text-sf-weak" data-id="element-694" data-mp="2chlri53uaif7">{row.basis}</span>
                </Td>
                <Td align="right" className={tone} data-id="element-695" data-mp="2hgyhuztx67mj">
                  {formatUsd(row.legacy)}
                </Td>
                <Td align="right" className={tone} data-id="element-696" data-mp="2lgz61c6tlx6s">
                  {formatUsd(row.next)}
                </Td>
                <Td align="right" className={`${row.primary ? 'font-semibold' : 'text-[12px]'} ${diff === 0 ? 'text-sf-green' : 'text-sf-red'}`} data-id="element-697" data-mp="2qfsgevqt982q">
                  {formatUsd(diff)}
                </Td>
              </tr>;
        })}
        </tbody>
      </table>
      <div className="flex flex-wrap items-center gap-2 px-4 py-2.5 text-xs text-sf-weak" data-id="element-698" data-mp="356sqt6b4bc1i">
        <Badge tone={mismatches === 0 ? 'successLight' : 'warning'} data-id="element-699" data-mp="39738hg89vqw7">{mismatches} mismatches</Badge>
      </div>
    </Card>;
}